<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Foreword">Foreword, by Mat Tombers</a></p>
<p class="TOC"><a href="#/Preface">Preface</a></p>
<p class="TOC"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="TOC2"><a href="#/Part1">P<span class="small">ART</span> I. T<span class="small">HE</span> B<span class="small">EGINNING</span></a></p>
<p class="TOC1"><a href="#/Chapter1">1. Taxation Without Representation Is Tyranny</a></p>
<p class="TOC1"><a href="#/Chapter2">2. The Mayhew Dynasty</a></p>
<p class="TOC1"><span href="#/Chapter3" title="Link target outside of Sample">3. The Stamp Act	</span></p>
<p class="TOC1"><span href="#/Chapter4" title="Link target outside of Sample">4. A Circular Letter</span></p>
<p class="TOC1"><span href="#/Chapter5" title="Link target outside of Sample">5. Vineyarders</span></p>
<p class="TOC1"><span href="#/Chapter6" title="Link target outside of Sample">6. Whaling</span></p>
<p class="TOC1"><span href="#/Chapter7" title="Link target outside of Sample">7. Tea Lane</span></p>
<p class="TOC2"><span href="#/Part2" title="Link target outside of Sample">P<span class="small">ART</span> II. T<span class="small">HE</span> M<span class="small">IDDLE</span></span></p>
<p class="TOC1"><span href="#/Chapter8" title="Link target outside of Sample">8. Nye on Naushon</span></p>
<p class="TOC1"><span href="#/Chapter9" title="Link target outside of Sample">9. Vineyard Defense</span></p>
<p class="TOC1"><span href="#/Chapter10" title="Link target outside of Sample">10. The <i>Harriot</i></span></p>
<p class="TOC1"><span href="#/Chapter11" title="Link target outside of Sample">11. Privateering</span></p>
<p class="TOC1"><span href="#/Chapter12" title="Link target outside of Sample">12. On Nathan Smith</span></p>
<p class="TOC1"><span href="#/Chapter13" title="Link target outside of Sample">13. On Sharper Michael</span></p>
<p class="TOC1"><span href="#/Chapter14" title="Link target outside of Sample">14. The Liberty Pole</span></p>
<p class="TOC1"><span href="#/Chapter15" title="Link target outside of Sample">15. Grey’s Raid</span></p>
<p class="TOC1"><span href="#/Chapter16" title="Link target outside of Sample">16. The <i>General Arnold</i></span></p>
<p class="TOC1"><span href="#/Chapter17" title="Link target outside of Sample">17. Salt</span></p>
<p class="TOC1"><span href="#/Chapter18" title="Link target outside of Sample">18. The Battle of Falmouth</span></p>
<p class="TOC1"><span href="#/Chapter19" title="Link target outside of Sample">19. The <i>Bonhomme Richard</i></span></p>
<p class="TOC2"><span href="#/Part3" title="Link target outside of Sample">P<span class="small">ART</span> III. T<span class="small">HE</span> E<span class="small">ND</span></span></p>
<p class="TOC1"><span href="#/Chapter20" title="Link target outside of Sample">20. On Nathan Daggett</span></p>
<p class="TOC1"><span href="#/Chapter21" title="Link target outside of Sample">21. On Beriah Norton</span></p>
<p class="TOC1"><span href="#/Chapter22" title="Link target outside of Sample">22. On Joseph Thaxter</span></p>
<p class="TOC3"><span href="#/Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="TOC"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="TOC"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?19576732